/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Billing_Board_Calm_BodyInputs */



/**
* | output |
* | --- |
* | "All {count} open partner-months have complete data and a confirmed tax country." |
*
* @param {Partner_Billing_Board_Calm_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_calm_body = /** @type {((inputs: Partner_Billing_Board_Calm_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Calm_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Alle ${i?.count} offenen Partnermonate haben vollständige Daten und ein bestätigtes Steuerland.`)
	return /** @type {LocalizedString} */ (`All ${i?.count} open partner-months have complete data and a confirmed tax country.`)
});